import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getSubscriptionStatus } from './helper';

/**
 * Subscription info is read from the `user` key of localStorage, the redux user is only
 * subscribed to so that consumers re-render after login / profile update.
 *
 * Returns `null` when no bar should be shown.
 */
const useSubscriptionStatus = () => {
    const reduxUser = useSelector((state) => state.AppReducer?.user);

    return useMemo(() => {
        let user;
        try {
            user = JSON.parse(localStorage.getItem('user')) || reduxUser || null;
        } catch {
            user = reduxUser || null;
        }
        return getSubscriptionStatus(user);
    }, [reduxUser]);
};

export default useSubscriptionStatus;
